import type { ChangeEvent } from "react";

/** Mesma forma de `Mascara` em @vetbolso/core, sem depender do pacote. */
type Mascara = { formatar: (v: string) => string; literal?: RegExp };

/**
 * Aplica a máscara no próprio campo e devolve o texto mascarado. O cursor fica
 * depois do mesmo caractere digitado em que estava, mesmo quando a máscara
 * insere ou remove separadores no meio. Serve para campos controlados (use o
 * retorno no estado) e não controlados (o valor já fica no campo).
 */
export function mascarar(e: ChangeEvent<HTMLInputElement>, m: Mascara): string {
  const campo = e.target;
  const antes = campo.value;
  const depois = m.formatar(antes);
  if (depois === antes) return depois;
  const conta = (s: string) => [...s].filter((c) => !m.literal?.test(c)).length;
  const cursor = campo.selectionStart ?? antes.length;
  const alvo = conta(m.formatar(antes.slice(0, cursor)));
  let pos = 0;
  for (let n = 0; pos < depois.length && n < alvo; pos++) if (!m.literal?.test(depois[pos])) n++;
  campo.value = depois;
  if (document.activeElement === campo) campo.setSelectionRange(pos, pos);
  return depois;
}
